//
// GTLContent.js
// gtl
//
// Generated by Robots v0.
// Copyright (c) SAS Institute Inc. All rights reserved.
//
// DO NOT EDIT THIS FILE. IT IS GENERATED BY ROBOTS.
//
// Disable camelcase rule for generated code.
/* eslint-disable camelcase */
import { createModule } from "@sas-dvr/ltjs-commons/moduleBuilder";
import EventDispatcher from "@sas-dvr/ltjs-commons/events/EventDispatcher";
import "../../lib";
import "./GTLModel";
import "./Layout";
import "../legend/Legend";
import "../entry/Entry";
import "../scatterPlotMatrix/ScatterPlotMatrix";

var GTLContent = createModule("gtl::GTLContent", ["commons::PropertyOwner","commons::BaseModel","gtl::GTLModel"], EventDispatcher, [
    ,
    {
        layout: 1,
        scatterPlotMatrix: 1,
        entry: 1,
        legend: 1,
    },
    ,
    ,
    ,
    {
        _create_v: [4],
        _create_o: [4,1],
    },
    ,
    ["_create"]
]);
export default GTLContent;
